import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState, ThunkApi } from 'state/store';
import { Option } from 'utils/customTypes';
import {
  InsightFilterOptions,
  LearningTeamsFilterAttributes,
} from 'api/normalized/insight/insightFiltersAPI';
import { JsonApiResource } from 'types/store/jsonApi';

/* ============================== STATE SETUP =============================== */
interface InsightFilterOptionsState {
  learningTeams: JsonApiResource<LearningTeamsFilterAttributes>[];
}

const initialState: InsightFilterOptionsState = {
  learningTeams: [],
};

/* ============================== REDUX THUNK =============================== */
export const getInsightFilters = createAsyncThunk<
  InsightFilterOptions,
  void,
  ThunkApi
>(
  'normalized/insightFilterOptions/getInsightFilters',
  async (_, { extra: { getInsightFiltersApi } }) => {
    const response = await getInsightFiltersApi().getFilters();
    return response;
  }
);

/* ================================= REDUCER ================================ */
const insightFilterOptionsSlice = createSlice({
  name: 'normalized/insightFilterOptions',
  initialState,
  reducers: {
    clearInsightFilterOptions: (state) => {
      state.learningTeams = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInsightFilters.fulfilled, (state, action) => {
      state.learningTeams = action.payload.learningTeams;
    });
  },
});

/* ================================ ACTIONS ================================= */
export const { clearInsightFilterOptions } = insightFilterOptionsSlice.actions;

/* =============================== SELECTORS ================================ */
const selectLearningTeamsOptions = (state: RootState): Option[] => {
  const learningTeams = state.normalized.insightFilterOptions.learningTeams;

  return learningTeams.map((learningTeam) => ({
    label: learningTeam.attributes.name,
    value: learningTeam.id,
  }));
};

export const insightFilterOptionsSelectors = {
  selectLearningTeamsOptions,
};

export default insightFilterOptionsSlice.reducer;
